import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { membersKeys } from "@/features/members/queries/membersQueryKeys";
import { sessionsKeys } from "@/features/sessions/queries/sessionsQueryKeys";
import bookingService from "@/features/sessions/services/bookingService";

type Variables = {
    attendanceId: string;
    sessionId: string;
    targetUid: string;
};

export function useRemoveAttendanceFromSession() {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: async ({ attendanceId, sessionId }: Variables) => {
            return bookingService.adminRemoveAttendance({ attendanceId, sessionId });
        },
        onError: (error) => {
            const message = error instanceof Error ? error.message : "Failed to remove booking. Please try again.";
            toast.error(message);
        },
        onSuccess: (_data, variables) => {
            queryClient.invalidateQueries({ queryKey: sessionsKeys.attendance.session(variables.sessionId) });
            queryClient.invalidateQueries({ queryKey: sessionsKeys.sessions.detail(variables.sessionId) });
            queryClient.invalidateQueries({ queryKey: membersKeys.detail(variables.targetUid) });
            queryClient.invalidateQueries({ queryKey: membersKeys.all });
            queryClient.invalidateQueries({
                queryKey: [...sessionsKeys.attendance.session(variables.sessionId), "status-counts"],
            });
            toast.success("Removed from session");
        },
    });

    return {
        error: mutation.error,
        isError: mutation.isError,
        isPending: mutation.isPending,
        mutate: mutation.mutate,
        mutateAsync: mutation.mutateAsync,
        variables: mutation.variables,
    };
}
